module.exports = __webpack_public_path__ + "img/api-spec-first-thumbnail.1d9d0944.jpg";